import { ChangeEvent, useEffect, useState } from 'react'

import { PlusOutlined } from '@ant-design/icons'
import { Button, Input, Space } from 'antd'
import { createStyles } from 'antd-style'
import { isNil, toNumber } from 'lodash'

import { isDecimal } from '@eastcoal/common/utils/decimal'
import { isEmpty } from '@eastcoal/common/utils/object'

import { AuctionBidInputNumberProps } from './interface'

const useStyles = createStyles(({ prefixCls, token }) => ({
  inputNumber: {
    flex: 1
  }
}))

export const AuctionBidInputNumber = ({
  // 允许的最大精度
  maxPrecision,
  disabled,
  max,
  value,
  onChange,
  onPlus,
  ...restProps
}: AuctionBidInputNumberProps) => {
  const { styles } = useStyles()

  const [innerVal, setInnerVal] = useState<string | number | undefined>()

  useEffect(() => {
    setInnerVal(value)
  }, [value])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let inptVal = e.target.value.trim()

    // 允许清空
    if (isEmpty(inptVal)) {
      onChange?.(undefined)
      return
    }

    // 需要让用户临时输入 . 号
    if (inptVal.endsWith('.')) {
      setInnerVal(inptVal)
      return
    }

    // 不准输入非数字
    if (!isDecimal(inptVal)) {
      return
    }

    // 不准超过最大精度
    if (!isNil(maxPrecision)) {
      const [integerPart, decimalPart] = inptVal.split('.')
      const currentPrecision = decimalPart?.length ?? 0
      if (currentPrecision > maxPrecision) {
        inptVal = integerPart + '.' + decimalPart.slice(0, maxPrecision)
      }
    }

    setInnerVal(inptVal)
    onChange?.(Number.parseFloat(inptVal))
  }

  const handlePlus = () => {
    if (!isNil(max) && toNumber(value) >= max) {
      return
    }
    onPlus?.(value)
  }

  return (
    <Space.Compact className={styles.inputNumber}>
      <Input
        {...restProps}
        disabled={disabled}
        max={max}
        placeholder='请输入'
        value={innerVal}
        onChange={handleChange}
      />
      <Button
        disabled={disabled}
        icon={<PlusOutlined />}
        type='default'
        onClick={handlePlus}
      />
    </Space.Compact>
  )
}
